const ButtonLink = () => import('../components/buttons/ButtonLink.vue')

export default {
  'button-link': ButtonLink,
}
